import * as React from "react";
import { useMobile } from "../../hooks/hooks.js";
import { WidthContainer } from "../WidthContainer";
import equipe from "./equipe.webp";

const Equipe = ({ }) => {
    const { mobile, tablet } = useMobile()
    return (
        <div
            id="Equipe"
            className=""
            {...{
                style: {
                    padding: "72px 0 196px 0",
                    color: "white"
                },
            }}
        >

            <WidthContainer center>


                <div   {...{
                    style: {
                        display: "grid",
                        gridTemplate: mobile ? `
                        "a"
                        "b"
                        `: `
                            "a b"
                            / 1fr .75fr
                        `,
                        placeContent: "start",
                        gap: mobile ? "40px" : "60px",
                        fontSize: (() => {
                            if (mobile) return "16px"
                            return "24px"
                        })(),
                        zIndex: "3",
                    },
                }}>
                    <div   {...{
                        style: {
                            gridArea: "a",
                        },
                    }}>
                        <h2   {...{
                            style: {
                                placeSelf: "center start",
                                fontSize: (() => {
                                    if (mobile) return "20px"
                                    return "36px"
                                })(),
                                fontWeight: 600,
                                margin: "0px 0px 48px 0px",
                            },
                        }}>
                            Notre équipe Happiz
                        </h2>
                        Notre équipe se compose d’une dizaine de praticiens, professionnels et passionés, tous certifiés en France avec plusieurs années d’expérience.
                        <br />
                        <br />
                        La force de notre équipe : la pluridisciplinarité des expertises. Chacune de nos séances est conçue par un praticien spécialisé dans un domaine précis : addictologie, hypnologie, psychothérapie, nutrition…
                        <br />
                        <br />
                        Mais avant tout, nous sommes tous liés par la même passion : faire du bien au plus grand nombre !
                    </div>

                    <div   {...{
                        style: {
                            gridArea: "b",
                            textAlign: "center",
                            fontWeight: 600
                        },
                    }}>

                        <img src={equipe} alt="" />
                        Équipe Happiz
                    </div>

                </div>
            </WidthContainer>

        </div>
    )
}

export { Equipe };
